// i18n keys of the multi-tenant work package "reqdocs" (en / zh / th). ⛔ Fill all three: an empty th value falls back to English.
export const en: Record<string, string> = {
  rqd_title: 'Required documents per service',
  rqd_desc: 'Before a job is marked Complete, the documents listed here for its service must be filed. A rule picks services by a name pattern; a job whose service matches no rule is not gated. A job with several services owes the documents of every matching rule, each once.',
  rqd_empty: 'No rules yet — no job is gated by required documents.',
  rqd_add: 'Add rule',
  rqd_test_label: 'Test a service name',
  rqd_test_ph: 'e.g. a service or job name',
  rqd_test_none: 'No rule matches — not gated.',
  rqd_test_rules: 'Matching rules',
  rqd_label: 'Name',
  rqd_label_ph: 'What this rule covers',
  rqd_match: 'Service names matching',
  rqd_match_hint: 'A regular expression, case-insensitive, tested against the job\'s service name.',
  rqd_not: 'Except names matching',
  rqd_expand: 'One set per type (optional)',
  rqd_expand_hint: 'A regular expression with one capture group naming the type. The documents below are then repeated for each type found in the name (at most {{max}}): {Type} in a name becomes the type, {_slug} in a key becomes _type.',
  rqd_docs: 'Documents, in order',
  rqd_add_doc: 'Add document',
  rqd_key: 'Key',
  rqd_key_hint: 'Permanent id: filed documents and some automations refer to it. Do not rename a key that is in use.',
  rqd_doc_name: 'Document name',
  rqd_date_kind: 'Date',
  rqd_required: 'Required',
  rqd_optional: 'Optional',
  rqd_no_email: 'Store only (never emailed)',
  rqd_folder: 'Folder hint',
  rqd_folder_hint: 'The archive folder\'s own name, when it differs from the document name.',
  rqd_company: 'Company in file name',
  rqd_company_auto: 'If the client is a company',
  rqd_company_never: 'Never',
  rqd_company_required: 'Required',
  rqd_when: 'Only when',
  rqd_when_hint: 'Optional regular expression tested against this rule\'s part of the job name; the document is owed only when it matches.',
  rqd_notes: 'Notes',
  rqd_active: 'Active',
  rqd_inactive: 'Inactive',
  rqd_filed: '{{n}} filed',
  rqd_docs_count: '{{n}} document(s)',
  rqd_test_draft: 'Test this draft',
  rqd_cancel: 'Cancel',
  rqd_save: 'Save',
  rqd_saved: 'Saved.',
  rqd_delete_confirm: 'Delete this rule? Jobs of these services will no longer be gated by it.',
  rqd_force_confirm: '{{msg}}\n\nContinue anyway?',
  rqd_discard: 'Discard the unsaved changes?',
  rqd_need_test_name: 'Type a service name in the tester first.',
  rqd_up: 'Move up',
  rqd_down: 'Move down',
  rqd_edit: 'Edit',
  rqd_delete: 'Delete',
  rqd_remove_doc: 'Remove document',
  rqd_dk_expiry: 'Expiry',
  rqd_dk_issued: 'Issued',
  rqd_dk_signed: 'Signed',
  rqd_dk_sent: 'Sent',
  rqd_dk_confirmed: 'Confirmed',
  rqd_dk_reviewed: 'Reviewed',
  rqd_dk_submitted: 'Submitted',
};
export const zh: Record<string, string> = {
  rqd_title: '各服务必收文档',
  rqd_desc: 'Job 标记为 Complete 之前,必须先归档其服务在此列出的文档。每条规则按服务名称模式匹配;服务未匹配任何规则的 Job 不设门禁。含多项服务的 Job 需提交所有匹配规则的文档,同一文档只算一次。',
  rqd_empty: '尚无规则 —— 目前没有任何 Job 受必收文档门禁约束。',
  rqd_add: '新增规则',
  rqd_test_label: '测试服务名称',
  rqd_test_ph: '例如服务名称或 Job 名称',
  rqd_test_none: '没有匹配的规则 —— 不设门禁。',
  rqd_test_rules: '匹配的规则',
  rqd_label: '名称',
  rqd_label_ph: '这条规则涵盖什么',
  rqd_match: '匹配的服务名称',
  rqd_match_hint: '正则表达式,不区分大小写,用于匹配 Job 的服务名称。',
  rqd_not: '排除匹配的名称',
  rqd_expand: '按类型逐套生成(可选)',
  rqd_expand_hint: '含一个捕获组(类型名)的正则表达式。下列文档会按名称中找到的每个类型各生成一套(最多 {{max}} 个):文档名中的 {Type} 替换为类型,键中的 {_slug} 替换为 _类型。',
  rqd_docs: '文档(按顺序)',
  rqd_add_doc: '新增文档',
  rqd_key: '键',
  rqd_key_hint: '永久标识:已归档的文档和部分自动流程引用它。正在使用的键不要改名。',
  rqd_doc_name: '文档名称',
  rqd_date_kind: '日期',
  rqd_required: '必收',
  rqd_optional: '选收',
  rqd_no_email: '只存档(绝不发邮件)',
  rqd_folder: '文件夹提示',
  rqd_folder_hint: '归档文件夹本身的名称(与文档名称不同时填写)。',
  rqd_company: '文件名中的公司名',
  rqd_company_auto: '客户为公司时',
  rqd_company_never: '不加',
  rqd_company_required: '必填',
  rqd_when: '仅当',
  rqd_when_hint: '可选的正则表达式,匹配本规则命中的那段 Job 名称;匹配时才需要此文档。',
  rqd_notes: '备注',
  rqd_active: '启用',
  rqd_inactive: '停用',
  rqd_filed: '已归档 {{n}}',
  rqd_docs_count: '{{n}} 份文档',
  rqd_test_draft: '测试此草稿',
  rqd_cancel: '取消',
  rqd_save: '保存',
  rqd_saved: '已保存。',
  rqd_delete_confirm: '删除这条规则?这些服务的 Job 将不再受它的门禁约束。',
  rqd_force_confirm: '{{msg}}\n\n仍要继续吗?',
  rqd_discard: '放弃未保存的修改?',
  rqd_need_test_name: '请先在测试框中输入服务名称。',
  rqd_up: '上移',
  rqd_down: '下移',
  rqd_edit: '编辑',
  rqd_delete: '删除',
  rqd_remove_doc: '移除文档',
  rqd_dk_expiry: '到期日',
  rqd_dk_issued: '签发日',
  rqd_dk_signed: '签署日',
  rqd_dk_sent: '发送日',
  rqd_dk_confirmed: '确认日',
  rqd_dk_reviewed: '审阅日',
  rqd_dk_submitted: '提交日',
};
export const th: Record<string, string> = {
  rqd_title: 'เอกสารที่ต้องจัดเก็บตามบริการ',
  rqd_desc: 'ก่อนทำเครื่องหมายงานว่าเสร็จสมบูรณ์ (Complete) ต้องจัดเก็บเอกสารที่ระบุไว้ที่นี่สำหรับบริการของงานนั้นให้ครบ กฎแต่ละข้อเลือกบริการตามรูปแบบชื่อ งานที่บริการไม่ตรงกับกฎใดจะไม่ถูกบังคับ งานที่มีหลายบริการต้องมีเอกสารของทุกกฎที่ตรงกัน โดยนับเอกสารแต่ละฉบับครั้งเดียว',
  rqd_empty: 'ยังไม่มีกฎ — ขณะนี้ไม่มีงานใดถูกบังคับให้ต้องมีเอกสาร',
  rqd_add: 'เพิ่มกฎ',
  rqd_test_label: 'ทดสอบชื่อบริการ',
  rqd_test_ph: 'เช่น ชื่อบริการหรือชื่องาน',
  rqd_test_none: 'ไม่มีกฎที่ตรงกัน — ไม่ถูกบังคับ',
  rqd_test_rules: 'กฎที่ตรงกัน',
  rqd_label: 'ชื่อ',
  rqd_label_ph: 'กฎนี้ครอบคลุมอะไร',
  rqd_match: 'ชื่อบริการที่ตรงกับ',
  rqd_match_hint: 'นิพจน์ปรกติ (regular expression) ไม่แยกตัวพิมพ์เล็กใหญ่ ใช้ทดสอบกับชื่อบริการของงาน',
  rqd_not: 'ยกเว้นชื่อที่ตรงกับ',
  rqd_expand: 'แยกชุดตามประเภท (ไม่บังคับ)',
  rqd_expand_hint: 'นิพจน์ปรกติที่มีกลุ่มจับหนึ่งกลุ่มสำหรับชื่อประเภท เอกสารด้านล่างจะถูกสร้างซ้ำสำหรับแต่ละประเภทที่พบในชื่อ (สูงสุด {{max}} ประเภท): {Type} ในชื่อเอกสารจะกลายเป็นชื่อประเภท และ {_slug} ในคีย์จะกลายเป็น _ประเภท',
  rqd_docs: 'เอกสาร ตามลำดับ',
  rqd_add_doc: 'เพิ่มเอกสาร',
  rqd_key: 'คีย์',
  rqd_key_hint: 'รหัสถาวร: เอกสารที่จัดเก็บแล้วและระบบอัตโนมัติบางส่วนอ้างอิงถึงรหัสนี้ ห้ามเปลี่ยนชื่อคีย์ที่ใช้งานอยู่',
  rqd_doc_name: 'ชื่อเอกสาร',
  rqd_date_kind: 'วันที่',
  rqd_required: 'บังคับ',
  rqd_optional: 'ไม่บังคับ',
  rqd_no_email: 'จัดเก็บเท่านั้น (ไม่ส่งทางอีเมล)',
  rqd_folder: 'ชื่อโฟลเดอร์',
  rqd_folder_hint: 'ชื่อโฟลเดอร์ในคลังเอกสาร หากต่างจากชื่อเอกสาร',
  rqd_company: 'ชื่อบริษัทในชื่อไฟล์',
  rqd_company_auto: 'เมื่อลูกค้าเป็นบริษัท',
  rqd_company_never: 'ไม่ใส่',
  rqd_company_required: 'บังคับ',
  rqd_when: 'เฉพาะเมื่อ',
  rqd_when_hint: 'นิพจน์ปรกติ (ไม่บังคับ) ใช้ทดสอบกับส่วนของชื่องานที่ตรงกับกฎนี้ ต้องมีเอกสารนี้เฉพาะเมื่อตรงกัน',
  rqd_notes: 'หมายเหตุ',
  rqd_active: 'ใช้งาน',
  rqd_inactive: 'ปิดใช้งาน',
  rqd_filed: 'จัดเก็บแล้ว {{n}}',
  rqd_docs_count: '{{n}} เอกสาร',
  rqd_test_draft: 'ทดสอบฉบับร่างนี้',
  rqd_cancel: 'ยกเลิก',
  rqd_save: 'บันทึก',
  rqd_saved: 'บันทึกแล้ว',
  rqd_delete_confirm: 'ลบกฎนี้หรือไม่? งานของบริการเหล่านี้จะไม่ถูกบังคับตามกฎนี้อีก',
  rqd_force_confirm: '{{msg}}\n\nดำเนินการต่อหรือไม่?',
  rqd_discard: 'ทิ้งการแก้ไขที่ยังไม่ได้บันทึกหรือไม่?',
  rqd_need_test_name: 'พิมพ์ชื่อบริการในช่องทดสอบก่อน',
  rqd_up: 'เลื่อนขึ้น',
  rqd_down: 'เลื่อนลง',
  rqd_edit: 'แก้ไข',
  rqd_delete: 'ลบ',
  rqd_remove_doc: 'นำเอกสารออก',
  rqd_dk_expiry: 'วันหมดอายุ',
  rqd_dk_issued: 'วันที่ออก',
  rqd_dk_signed: 'วันที่ลงนาม',
  rqd_dk_sent: 'วันที่ส่ง',
  rqd_dk_confirmed: 'วันที่ยืนยัน',
  rqd_dk_reviewed: 'วันที่ตรวจทาน',
  rqd_dk_submitted: 'วันที่ยื่น',
};
